// @flow
import React from "react";
import { useSelector } from "react-redux";
import { Translate } from "@quantum/i18n";

import {
  SelecaoCasasDecimais,
  SelecaoPeriodo,
  SelecaoPeriodicidade,
  SelecaoAjusteDias,
  SelecaoLimite,
  SelecaoJanelaMovel,
} from "../configuracoes";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getDataBaseSelecionadaAsString,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../state";

export const processarPeriodoComLimite = comGeradorDePeriodo(
  (state, medidas) => {
    const edicaoMedida = getEdicaoMedida(state);
    const dataBase = getDataBaseSelecionadaAsString(state);
    const modoSeries = isModoSeries(state);

    if (modoSeries) {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        limite: edicaoMedida.limite,
        tipoDoRetorno: edicaoMedida.tipoDoRetorno,
        janelaMovel: edicaoMedida.janelaMovel,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    } else {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        periodicidade: edicaoMedida.periodicidade,
        ajusteDias: edicaoMedida.ajusteDias,
        limite: edicaoMedida.limite,
        tipoDoRetorno: edicaoMedida.tipoDoRetorno,
        dataBase: dataBase,
        janelaMovel: edicaoMedida.janelaMovel,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    }
  }
);

const PeriodoComLambda = () => {
  const modoSeries = useSelector(isModoSeries);

  if (modoSeries) {
    return (
      <>
        <div className="ConfiguracaoMedida">
          <h3 className="ConfiguracaoMedida__group-title">
            <Translate>configuracaoRelatorio.parametros</Translate>
          </h3>
          <div className="ConfiguracaoMedida__group--grey">
            <div className="ConfiguracaoMedida__box">
              <SelecaoLimite />
            </div>
          </div>
        </div>

        <div className="ConfiguracaoMedida__vertical-divider" />

        <div className="ConfiguracaoMedida">
          <SelecaoJanelaMovel />
        </div>
      </>
    );
  } else {
    return (
      <div className="ConfiguracaoMedida--flex">
        <div className="ConfiguracaoMedida--flex">
          <SelecaoPeriodo exibirPeriodicidade={false} />
        </div>

        <div className="ConfiguracaoMedida">
          <div className="ConfiguracaoMedida__box">
            <SelecaoPeriodicidade />
          </div>
          <div className="ConfiguracaoMedida__box">
            <SelecaoAjusteDias />
          </div>
        </div>

        <div className="ConfiguracaoMedida__vertical-divider" />

        <div className="ConfiguracaoMedida">
          <h3 className="ConfiguracaoMedida__group-title">
            <Translate>configuracaoRelatorio.parametros</Translate>
          </h3>
          <div className="ConfiguracaoMedida__group--grey">
            <div className="ConfiguracaoMedida__box">
              <SelecaoLimite />
            </div>
          </div>
        </div>

        <div className="ConfiguracaoMedida__vertical-divider" />
        <SelecaoCasasDecimais />
      </div>
    );
  }
};

export default PeriodoComLambda;
